import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Flex, Select, Divider, Row, Col, Statistic } from 'antd';
import CustomerService from "services/customer"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useNavigate } from 'react-router';
import CustomerInfoModal from "components/customer/InfoModal2"
import _ from "lodash"
const service = new CustomerService();
const { Search } = Input;
const OrderList = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [filter, setFilter] = useState({ info: "" })
    const [clickPhone, setClickPhone] = useState("");
    const [showCustomerInfo, setShowCustomerInfo] = useState(false);

    // useEffect(() => {
    //     loadData({});
    // }, [])

    useEffect(() => {
        delaySearch(filter);
    }, [filter])

    const loadData = async (data) => {
        var lst = await service.list(data);
        setData(lst);
    }

    const delaySearch = useMemo(() => _.debounce(loadData, 500), []);

    const onSearch = () => {
        delaySearch({});
    }

    const setFilterValue = (name, value) => {

        var newFilter = { ...filter };
        newFilter[name] = value;
        setFilter(newFilter)
    }
    const updateStats = async (id) => {
        await service.updateStats(id);
        loadData();
    }

    const showCustomer = phone => {
        setClickPhone(phone);
        setShowCustomerInfo(true);
    }


    const columns = [
        {
            title: 'Khách hàng',
            render: (record) => {

                return (
                    <Space direction='vertical'>
                        <Button type='text' onClick={e => showCustomer(record.id)} >
                            {record.phone}
                        </Button>
                        <div>
                            {record.full_name}
                        </div>
                    </Space>
                )

            }
        },

        {
            title: 'Điểm tích luỹ',
            sorter: (a, b) => (a.loyalty_point?.current ?? 0) - (b.loyalty_point?.current ?? 0),
            render: (record) => {
                return (
                    <Space direction='vertical'>
                        <div>
                            {formatCurrency(record.loyalty_point?.current)}
                        </div>

                    </Space>
                )


            }
        },


        {
            title: 'Doanh Thu',
            sorter: (a, b) => a.stats?.total_spend - b.stats?.total_spend,
            render: (record) => {
                return (
                    <Space direction='vertical'>
                        <div>
                            {formatCurrency(record.stats?.total_spend)}
                        </div>

                    </Space>
                )


            }
        },

        {
            title: 'Gần Đây',
            sorter: (a, b) => a.stats?.recent_spend - b.stats?.recent_spend,
            render: (record) => {
                return (
                    <Space direction='vertical'>
                        <div>
                            {formatCurrency(record.stats?.recent_spend)}
                        </div>

                    </Space>
                )


            }
        },



        {
            title: 'Đơn hàng gần đây',

            render: (record) => {
                return (
                    <Space direction='vertical'>

                        {record.stats?.last_order?.id &&
                            <>
                                <div onClick={e=>navigate(`/order/${record.stats?.last_order?.id}`)}>{record.stats?.last_order?.id}</div>
                                <div>
                                    {formatCurrency(record.stats?.last_order.total_amount)}
                                </div>
                                <div>
                                    {formatDate(record.stats?.last_order.create_on)}
                                </div>
                            </>
                        }


                    </Space>
                )


            }
        },






    ];

    return (
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
            <Card style={{ width: "100%" }}>
                <Space direction='vertical' style={{ width: "100%" }}>


                    <Search
                        placeholder="Số điện thoại hoặc tên"
                        onSearch={onSearch}
                        onChange={e => setFilterValue("info", e.target.value)}
                        style={{
                            width: "100%",
                        }}
                    />

                </Space>
                <Divider></Divider>
                <Row gutter={16}>
                    <Col span={12}>
                        <Statistic title="Tổng số khách hàng" value={data.length} />
                    </Col>
                    <Col span={12}>
                        <Statistic title="Tổng số xu" value={_.sumBy(data, x => x.loyalty_point?.current ?? 0)} precision={0} />

                    </Col>

                </Row>
            </Card>
            <Card style={{ width: "100%" }}>
                <Table dataSource={data} columns={columns} />
            </Card>
            <CustomerInfoModal id={clickPhone} open={showCustomerInfo} onClose={e => setShowCustomerInfo(false)} onSave = {loadData}></CustomerInfoModal>
        </Space>
    )
}

export default OrderList;
